import { useSelector } from 'Modules/core/redux';

import { CONFIG_REDUCER_PATH } from './utils';


export const useConfig = <T = string>(path: string): T | undefined =>
    useSelector(`${CONFIG_REDUCER_PATH}.${path}`, [path]);
